/**
 * Payload-aligned types for the fumigation application form.
 * Keys match the API request body exactly.
 */

export interface FumigationRecord {
    id?: number;
    customerName: string;
    premiseAddress: string;
    closeSchedule: string;
    closeTime: string;
    restoreSchedule: string;
    restoreTime: string;
    qty: number;
    aer: string;
    accessArrangements: string;
    codeType: string;
    code: string;
}

export interface applicationData {
    // Company / Contractor info
    fumigationCompanyName: string;
    contactPerson: string;
    telephoneAreaCode: string;
    telephoneMid3: string;
    telephoneLast4: string;
    telephoneExtension: string;
    emailAddress: string;

    // Alternate contact
    alternateContact: string;
    alternateAreaCode: string;
    alternateMid3: string;
    alternateLast4: string;
    alternateExtension: string;
    alternateEmailAddress: string;

    // Customer / Premises records
    records: FumigationRecord[];

    // Additional info
    additionalAccessInformation: string;
}

export const EMPTY_RECORD: FumigationRecord = {
    customerName: '',
    premiseAddress: '',
    closeSchedule: '',
    closeTime: 'AM',
    restoreSchedule: '',
    restoreTime: 'AD',
    qty: 1,
    aer: 'Sched',
    accessArrangements: 'None',
    codeType: 'None',
    code: '',
};

export const initialApplicationDataFieldValues: applicationData = {
    fumigationCompanyName: '',
    contactPerson: '',
    telephoneAreaCode: '',
    telephoneMid3: '',
    telephoneLast4: '',
    telephoneExtension: '',
    emailAddress: '',

    alternateContact: '',
    alternateAreaCode: '',
    alternateMid3: '',
    alternateLast4: '',
    alternateExtension: '',
    alternateEmailAddress: '',

    records: [],

    additionalAccessInformation: '',
};

export const getInitialApplicationData = (): applicationData => ({
    ...initialApplicationDataFieldValues,
});

// Legacy alias kept for backward compat with imports that reference the old name
export type applicationDataFieldTypes = applicationData;
